import React from 'react';
import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <div className="bg-sand-50 text-foreground min-h-[80vh] flex items-center justify-center px-6 py-20">
      <div className="max-w-md text-center flex flex-col items-center gap-6">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-clay-100 text-clay-700">
          <i className="fa-light fa-lock-keyhole text-4xl" />
        </div>
        <h1 className="font-serif text-4xl font-bold text-black tracking-wide">
          Adgang nægtet (403)
        </h1>
        <p className="text-foreground/70 leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os.
        </p>
        <Link
          to="/"
          className="rounded-full bg-cta hover:bg-cta-hover text-clay-900 py-3 px-8 text-xs uppercase tracking-widest font-bold transition-all shadow-md active:scale-98"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
}
